import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { FaLock } from "react-icons/fa";

export default function PremiumContentBanner({ authorName, className = "" }) {
  const { user } = useContext(AuthContext);
  
  // Check if user has an active subscription
  const hasActiveSubscription = user && user.subscription && user.subscription.status === 'active';
  
  // If user has an active subscription, don't show the banner
  if (hasActiveSubscription) {
    return null;
  }
  
  return (
    <div className={`bg-gradient-to-b from-white to-taupe/10 p-8 rounded-lg text-center ${className}`}>
      <div className="inline-block p-3 bg-taupe/20 rounded-full mb-4">
        <FaLock className="text-taupe-dark text-xl" />
      </div>
      
      <h3 className="text-2xl font-serif mb-2">
        This is premium content
      </h3>
      
      <p className="text-gray-700 mb-6">
        Subscribe to {authorName}'s premium content to continue reading this article and get access to all premium articles.
      </p>
      
      <div className="space-y-3">
        <button className="w-full px-6 py-3 bg-taupe text-white rounded-lg hover:bg-taupe-dark font-medium">
          Subscribe for £5/month
        </button>
        
        <button className="w-full px-6 py-3 bg-white border border-taupe text-taupe rounded-lg hover:bg-taupe/5 font-medium">
          Subscribe for £50/year
        </button>
        
        {!user && (
          <div className="pt-4 border-t mt-4">
            <p className="text-gray-600 mb-2">Already a subscriber?</p>
            <button 
              onClick={() => window.location.href = "https://actadiurna.auth.eu-west-2.amazoncognito.com/login?client_id=4bi8nq055s0vrr43s3qc76p8jk&response_type=token&scope=email+openid+profile&redirect_uri=https%3A%2F%2Factadiurna.org.uk%2F"}
              className="text-taupe hover:underline font-medium"
            >
              Sign in
            </button>
          </div>
        )}
      </div>
    </div>
  );
}